export enum DlpTemplateModalNameEnum {
  None = 'none',
  Add = 'add',
  Delete = 'delete',
  Import = 'import',
  Edit = 'edit',
}

export type DlpTemplateModalState =
  | {
      name: DlpTemplateModalNameEnum.None | DlpTemplateModalNameEnum.Import;
      data: any;
    }
  | {
      name: DlpTemplateModalNameEnum.Delete;
      data: {
        cfgIndex: string;
        dpTemplateName: string;
        dpTemplateDesc: string;
      };
    }
  | {
      name: DlpTemplateModalNameEnum.Edit;
      data: {
        cfgIndex: string;
      };
    }
  | {
      name: DlpTemplateModalNameEnum.Add;
      data: null;
    };
